const defaults = {
    interaction_name: 'Menu Revamp', // experiment name
    page_interaction: 'Product click - item name', // description of interaction
    event: 'menu_interaction'
};

function track(arg) {
    const dataLayer =
        (typeof window !== 'undefined' && window.dataLayer) || null;
    let trackingParams;

    if (typeof arg === 'string') {
        trackingParams = {
            page_interaction: arg
        };
    } else {
        trackingParams = arg;
    }

    return function addTracking() {
        const DEBUG = typeof window !== 'undefined' && window.DEBUG;
        if (dataLayer && trackingParams) {
            const trackingObject = {
                ...defaults,
                ...trackingParams
            };
            dataLayer.push(trackingObject);
            if (DEBUG) {
                console.log('track', trackingObject);
            }
        }
    };
}

export { track };
